import { TitleWithDescription } from "@/components/shared";
import { CircularProgress, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";

const WaitFetchProfile = () => {

    const { t } = useTranslation()

  return (
    <Stack spacing={3} alignItems="center">
      <TitleWithDescription
        spacing={1}
        alignment={"center"}
        title={t("common:wait_for_fetching_profile")}
        description={t("common:please_wait")}
        primaryColor="text.primary"
        headerVariant="subtitleBlack"
        descriptionVariant="bodyMedium"
      />
      <CircularProgress />
    </Stack>
  );
};

export default WaitFetchProfile